import React, { useEffect, useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useNavigate } from 'react-router-dom'
import './Dashboard.css'
import { auth, db, logout } from '../../Firebase'
import { query, collection, getDocs, where } from 'firebase/firestore'
import BuyPlan from '../Payment/BuyPlan'

function Dashboard() {
  const [user, loading, error] = useAuthState(auth)
  const [name, setName] = useState('')
  const navigate = useNavigate()
  const fetchUserName = async () => {
    try {
      const q = query(collection(db, 'users'), where('uid', '==', user?.uid))
      const doc = await getDocs(q)
      const data = doc.docs[0].data()
      setName(data.name)
    } catch (err) {
      console.error(err)
      alert('An error occured while fetching user data')
    }
  }
  useEffect(() => {
    if (loading) return
    if (!user) return navigate('/')
    fetchUserName()
  }, [user, loading])
  return (
    <>
      {loading ? (
        <div className="loading-screen-page">
          <h2 className="medium-bold">Loading...</h2>
        </div>
      ) : (
        <div className="dashboard">
          <div className="dashboard__container">
            Logged in as
            <div>{name}</div>
            <div>{user?.email}</div>
            <button className="dashboard__btn" onClick={logout}>
              Logout
            </button>
          </div>
          {/* <BuyPlan /> */}
        </div>
      )}
    </>
  )
}
export default Dashboard
